import http from "@/api";

let _registered = false;

export async function registerNativePush() {
  if (_registered) return;
  try {
    const Cap = window.Capacitor;
    if (!Cap?.isNativePlatform?.()) return;
    const PN = Cap.Plugins?.PushNotifications;
    if (!PN) return; // old app build without the plugin
    const perm = await PN.requestPermissions();
    if (perm.receive !== "granted") return;
    _registered = true;
    await PN.addListener("registration", async ({ value }) => {
      try { await http.post("/push/apns/register", { token: value }); } catch { /* */ }
    });
    await PN.addListener("pushNotificationActionPerformed", (ev) => {
      const url = ev?.notification?.data?.url;
      if (url) window.location.href = url;
    });
    await PN.register();
  } catch { /* never break the app for push */ }
}
